import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Download, Upload } from 'lucide-react';

/**
 * Profile JSON backup card extracted from Settings.jsx (line 965-1016).
 * Pure presentational; all logic stays in the parent (handleExportProfile, handleImportProfileFile).
 */
export function ProfileBackupCard({ language, user, onExport, onImportFile }) {
    const isDe = language === 'de';
    return (
        <Card data-testid="profile-backup-card">
            <CardHeader>
                <CardTitle className="text-lg flex items-center gap-2">
                    <Download className="w-5 h-5 icon-primary" />
                    {isDe ? 'Profil-Backup' : 'Profile Backup'}
                </CardTitle>
                <CardDescription>
                    {isDe
                        ? 'Sichere alle deine persönlichen Ziele und Daten als JSON-Datei. Bei Bedarf einfach wieder importieren.'
                        : 'Save all your personal goals and settings as a JSON file. Import it back anytime.'}
                </CardDescription>
            </CardHeader>
            <CardContent className="space-y-2">
                <Button
                    variant="outline"
                    className="w-full justify-start gap-2"
                    onClick={onExport}
                    disabled={!user}
                    data-testid="profile-export-btn"
                >
                    <Download className="w-4 h-4" />
                    {isDe ? 'Profil exportieren (JSON)' : 'Export profile (JSON)'}
                </Button>
                <input
                    id="profile-import-file"
                    type="file"
                    accept="application/json,.json"
                    className="hidden"
                    onChange={(e) => {
                        const f = e.target.files?.[0];
                        if (f) onImportFile(f);
                        e.target.value = '';
                    }}
                    data-testid="profile-import-input"
                />
                <Button
                    variant="outline"
                    className="w-full justify-start gap-2"
                    onClick={() => document.getElementById('profile-import-file')?.click()}
                    data-testid="profile-import-btn"
                >
                    <Upload className="w-4 h-4" />
                    {isDe ? 'Profil importieren (JSON)' : 'Import profile (JSON)'}
                </Button>
                <p className="text-[11px] text-muted-foreground mt-1">
                    {isDe
                        ? 'Tipp: Speichere die Datei in iCloud oder Notizen — so kommst du jederzeit wieder dran.'
                        : 'Tip: Save the file in iCloud or Notes — quick to recover anytime.'}
                </p>
            </CardContent>
        </Card>
    );
}
